import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './ContentModuleTab.style';
import Card from '../../components/Card';

const ContentModuleTab = ({ headerText, itemCount, isSmallScreen }) => {
  const cardWrapper = clsx(styles.cardWrapperLarge, {
    [styles.cardWrapperSmall]: isSmallScreen,
  });
  const tabLabel = clsx(styles.tabLabelLarge, {
    [styles.tabLabelSmall]: isSmallScreen,
  });
  const tabSummary = clsx(styles.tabSummaryLarge, {
    [styles.tabSummarySmall]: isSmallScreen,
  });
  return (
    <div className={clsx(styles.root)}>
      <ul className={styles.tabs}>
        <li className={styles.tabWrapper}>
          <Card className={cardWrapper}>
            <Text as="p" variant="small" className={tabLabel}>
              {headerText}
            </Text>
            <Text as="p" variant="small" className={tabSummary}>
              {itemCount}
            </Text>
          </Card>
        </li>
      </ul>
    </div>
  );
};

ContentModuleTab.propTypes = {
  headerText: PropTypes.string,
  itemCount: PropTypes.string,
  isSmallScreen: PropTypes.bool,
};

ContentModuleTab.defaultProps = {
  headerText: '',
  itemCount: '',
  isSmallScreen: false,
};

export default ContentModuleTab;
